import { __assign } from "tslib";
/**
 * 合并默认选项，返回新的选项
 * @param defaultOption 默认选项
 * @param option 需要合并默认选项的选项
 */

export function withDefaultOption(defaultOption, option) {
  return __assign(__assign({}, defaultOption), option);
}